import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const baseUrl = '/api/service-providers';

const getServiceProvider = async (
    config,
    serviceProviderId,
    options = {
        with: []
    }
) => {
    return await axios
        .get(buildUrl(`${baseUrl}/${serviceProviderId}`, options), config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return null
        })
}

const getServiceProviders = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const serviceProviderAPI = {
    getServiceProviders,
    getServiceProvider
}

export default serviceProviderAPI
